import {
  APP_MANAGED_ROUTES,
  RegionSelectionClaims,
  ClaimsDetailDisclaimer,
} from '@highmark-web/highmark-common';
import { LeagueCombinedConfig } from '@leagueplatform/core';

export function getClaimsConfig(): LeagueCombinedConfig['claims'] {
  return {
    showTotalCostOverviewAndAdditionalResources: false,
    supportLink: APP_MANAGED_ROUTES.SUPPORT,
    enableDynamicFilters: true,
    featureFlags: {
      shouldShowClaimDetails: true,
      shouldShowDownloadClaims: true,
      shouldShowFilterChips: true,
    },
    slots: {
      Banner: RegionSelectionClaims,
      ServiceDetailsBanner: ClaimsDetailDisclaimer,
    },
    showHealthInsuranceGlossary: true,
  };
}
